import React, {useEffect, useState} from 'react';
import $ from "jquery";
import moment from "moment";
import {
    GET_COLLECTION_DATA
} from "../../../api";
import cogoToast from "cogo-toast";
import {deposit, getUser, media, user} from "../../../api/app";
import {capitalize} from "../../../utils/capitalize";
import formatNumber from "../../../utils/formatNumber";

const MembershipData = (props) => {

    const token = localStorage.getItem('jwtToken');

    const id = props.match.params.id;
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [balance, setBalance] = useState(0);
    const [wallet, setWallet] = useState(null);
    const [reset, setReset] = useState(new Date().getTime());
    const [stateReady, setStateReady] = useState(false);
    const [datatable] = useState({
        media: false,
        fund: false,
        monetize: false,
        withdrawal: false
    });

    useEffect(() => {
        getUser(id).then((response) => {
            if(!response.error) {
                setUserData(response.payload.user);
                setBalance(response.payload.balance);
                setWallet(response.payload.wallet);
                setLoading(false);
            }
        });
    }, [reset]);

    const mediaDatatable = () => {
        if(datatable.media) return false;
        datatable.media = true;
        const table = $('#media-dt').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Media Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "media",
                        fieldname: "description",
                        filter: {
                            user: userData._id
                        },
                        pageSize: data.start,
                        format: 'json',
                        populate: "user",
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.code;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Active</span>`,
                            false : `<span class="badge badge-secondary tx-white">Inactive</span>`
                        }[data.active];
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            true : `<span class="badge badge-success tx-white">Approved</span>`,
                            false : `<span class="badge badge-primary tx-white">Pending</span>`
                        }[data.approved];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link approve-content"><i class="fa fa-pencil"></i> Approve</a> <a href="#" class="nav-link delete-media"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete-media', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            $(".data-message").text(`Are you sure, you want to delete content?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                media("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        $('#media-dt').DataTable().ajax.reload(null, false);
                        cogoToast.success("Content successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.approve-content', function(e) {
            e.preventDefault();

            const options = {
                position: "top-right",
                hideAfter: 0
            };

            let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

            let extract_td = table.row($(this).closest('tr')).data();

            let data = {
                action: "approve",
                id: extract_td.raw._id
            }

            media("put", data).then((result) => {
                hide();
                if(!result.error) {
                    $('#media-dt').DataTable().ajax.reload(null, false);
                    setReset(new Date().getTime());
                    cogoToast.success("Content successfully removed.", {position: "top-right"});
                }
            });
        });

        $('#media-dt tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Description:</td>' +
                '<td>' +
                `${d.raw.description}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Resource File:</td>' +
                '<td>' +
                `<nav class="nav nav-icon-only"><a target="_blank" href="${d.raw?.files[0]?.uri}" class="nav-link"><i class="fa fa-eye"></i> View File</a></nav>` +
                '</td>' +
                '</tr>' +
                '</table>'
            );
        }
    }

    const fundDatatable = () => {
        if(datatable.fund) return false;
        datatable.fund = true;

        let table = $('#fund-dt').DataTable({
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Fund Data</p>'
            },
            processing: true,
            serverSide: true,
            responsive: true,
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            pageLength: 10,
            ajax: function(data, callback) {
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "grant",
                        fieldname: "reg_number",
                        filter: {
                            user: userData._id
                        },
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `K${formatNumber(data.amount)}`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return capitalize(data.business_type);
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.req_number;
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 4
                }
            ]
        });

        $('#fund tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Description:</td>' +
                '<td>' +
                `${d.raw.description}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '</table>'
            );
        }
    }

    const monetizeDatatable = () => {
        if(datatable.monetize) return false;
        datatable.monetize = true;
        $('#monetize-dt').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Monetize Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "monetize",
                        fieldname: "type",
                        filter: {
                            user: userData._id
                        },
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.amount;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return {
                            "media" : `<span class="badge badge-success tx-white">Media</span>`,
                            "referral" : `<span class="badge badge-primary tx-white">Referral</span>`
                        }[data.mode];
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 2
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_user"><i class="fa fa-pencil"></i> Approve</a> <a href="#" class="nav-link delete_user"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });
    }

    const withdrawalDatatable = () => {
        if(datatable.withdrawal) return false;
        datatable.withdrawal = true;
        $('#withdrawal-dt').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Withdrawal Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "transactions",
                        fieldname: "txn_number",
                        filter: {
                            user: userData._id
                        },
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.txn_number;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(data.gateway);
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `K${formatNumber(data.amount)}`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            "withdraw" : `<span class="badge badge-success tx-white">Withdraw</span>`,
                            "credit" : `<span class="badge badge-primary tx-white">Credit</span>`
                        }[data.type];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 4
                }
            ]
        });
    }

    const handleApprove = (action) => {
        const options = {
            position: "top-right",
            hideAfter: 0
        };

        let {hide} = cogoToast.loading('Please wait... contacting to server.', options);
        let data = {
            action: action,
            id: userData._id
        }

        user("put", data).then((result) => {
            hide();
            if(!result.error) {
                setReset(new Date().getTime());
                cogoToast.success("Account successfully approved.", {position: "top-right"});
            }
        });
    }

    const handleReject = () => {
        $("#rejection_form").parsley();
        $("#modalRejection").modal({ backdrop: 'static', focus: false, show: true });
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handleRejectionSubmit = (e) => {
        e.preventDefault();

        const options = {
            position: "top-right",
            hideAfter: 0
        };

        let {hide} = cogoToast.loading('Please wait... contacting to server.', options);
        let data = {
            action: "reject",
            remark: $("#reason").val(),
            id: userData._id
        }

        user("put", data).then((result) => {
            hide();
            if(!result.error) {
                setReset(new Date().getTime());
                resetForm( "modalRejection", "rejection_form")
                cogoToast.success("Account successfully rejected.", {position: "top-right"});
            }
        });
    }

    const handleDepositSubmit = (e) => {
        e.preventDefault();

        const options = {
            position: "top-right",
            hideAfter: 0
        };

        let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

        let data = {
            amount: $("#amount").val(),
            id: wallet
        }

        deposit("put", data).then((result) => {
            hide();
            if(!result.error) {
                setReset(new Date().getTime());
                resetForm( "modalDeposit", "deposit_form")
                cogoToast.success(result.payload, {position: "top-right"});
            }
        });
    }

    const modalUserForm = () => {
        $('#user_form').parsley();
        $("#name").val(userData.name);
        $("#id_number").val(userData.id_number);
        $("#gender").val(userData.gender);
        $("#mobile").val(userData.mobile_number);
        $("#modalUser").modal({ backdrop: 'static', focus: false, show: true });
    }

    const handleUserSubmit = (e) => {
        e.preventDefault();
        setStateReady(true);

        let data = {
            action: "profile",
            id: userData._id,
            name : $("#name").val(),
            id_number: $("#id_number").val(),
            gender : $("#gender").val(),
            mobile_number : $("#mobile").val(),
            password: $("#password").val()
        }

        user("put", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                setReset(new Date().getTime());
                resetForm("modalUser", "user_form");
            }
        })

        return false;
    }

    const handleDepositModal = () => {
        $("#deposit_form").parsley();
        $("#modalDeposit").modal("show");
    }

    if(!loading) {
        return (
            <div className="content-body">
                <div className="container-fluid pd-x-0">
                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                    <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                    <li className="breadcrumb-item"><a href="#">Customer</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Details</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-none d-md-block">
                            {userData.active ? <span className="badge badge-success tx-white">Active</span> :
                                <span className="badge badge-danger tx-white">Inactive</span>}
                        </div>
                    </div>

                    <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                        <div className="media">
                            <div
                                className="wd-100 ht-100 bg-ui-04 rounded d-flex align-items-center justify-content-center bg-white">
                                {userData.photo_uri ?
                                    <img src={userData.photo_uri} className="img-fit-cover rounded-5" alt="logo"/> :
                                    <span className="link-03 lh-0 text-center"><i style={{fontSize: 50}} className="icon ion-md-camera"></i><p className="text-center tx-color-03 mt-2 tx-13">No Photo</p></span>}
                            </div>
                            <div className="media-body pd-l-25 my-auto">
                                <h5 className="mg-b-5 text-capitalize">{userData.name}</h5>
                                <p className="mg-b-3 text-capitalize">
                                    <span className="tx-medium tx-color-02 text-capitalize">{userData.gender}</span><br/>
                                    Zambia
                                </p>
                                <span className="d-block tx-13 tx-color-03">{userData.mobile_number}</span>
                            </div>
                        </div>
                        <div className="media align-items-center">
                            <div className="media-body mg-l-10 my-auto">
                                <div className="d-flex">
                                    <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase outline-none mb-3 mg-r-5" onClick={modalUserForm.bind()}><i className="wd-10 mg-r-5 fa fa-pencil"></i> Edit Profile</button>
                                    <button className="btn btn-sm pd-x-15 btn-danger btn-uppercase outline-none mb-3" onClick={handleDepositModal.bind()}><i className="wd-10 mg-r-5 fa fa-arrow-up"></i> TopUp Balance</button>
                                </div>
                                <div className="float-right">
                                    <h6 className="tx-10 tx-lg-12 tx-medium tx-uppercase tx-spacing-1 tx-gray-800 mg-b-5">Wallet Balance <span className="tx-normal tx-color-03">(ZMW)</span></h6>
                                    <div className="d-flex align-items-baseline">
                                        <h2 className="tx-13 tx-lg-24 tx-bold tx-rubik tx-spacing--2 lh-2 mg-b-0">K{formatNumber(balance)}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row row-xs">
                        <div className="col-md-12 mg-t-10">
                            <div className="nav-wrapper mg-b-20 tx-13">
                                <div>
                                    <ul id="nav_basic" className="nav nav-line nav-fill tx-medium">
                                        <li className="nav-item"><a href="#basic " className="nav-link active" data-toggle="tab"><i className="ion-md-information-circle"/> User Info</a></li>
                                        <li className="nav-item"><a href="#media" className="nav-link" data-toggle="tab" onClick={mediaDatatable.bind()}><i className="ion-md-document"/> Media</a></li>
                                        <li className="nav-item"><a href="#fund" className="nav-link" data-toggle="tab" onClick={fundDatatable.bind()}><i className="ion-md-cash"/> Funding</a></li>
                                        {/*<li className="nav-item"><a href="#monetize" className="nav-link" data-toggle="tab" onClick={monetizeDatatable.bind()}><i className="ion-md-gift"/> Monetize</a></li>*/}
                                        <li className="nav-item"><a href="#withdrawal" className="nav-link" data-toggle="tab" onClick={withdrawalDatatable.bind()}><i className="ion-md-arrow-round-up"/> Withdrawal</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="tab-content">
                                <div id="basic" className="tab-pane fade active show">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <p><strong>Username:</strong> {userData.username}</p>
                                            <p><strong>Mobile #:</strong> {userData.mobile_number}</p>
                                            <p><strong>NRC #:</strong> {userData.id_number}</p>
                                            <p><strong>Gender:</strong> {capitalize(userData.gender)}</p>
                                            <p><strong>Provincial:</strong> {userData.location.provincial.name}</p>
                                            <p><strong>Constituency:</strong> {userData.location.constituency.name}</p>
                                            <p className="d-flex"><strong>Qualification:</strong> {userData.qualification ? <nav className="nav nav-icon-only ml-1"><a target="_blank" href={userData.qualification?.document?.uri} className="nav-link ml-2"><i className="fa fa-eye"></i> View Qualification</a></nav> : <span className="ml-1">No Qualification</span>}</p>
                                            <p className="d-flex"><strong>NRC Document:</strong> {userData.documents.length > 0 ? <nav className="nav nav-icon-only ml-1"><a target="_blank" href={userData.documents[0].uri} className="nav-link"><i className="fa fa-eye"></i> View NRC Front</a> <a target="_blank" href={userData.documents[1].uri} className="nav-link"><i className="fa fa-eye"></i> View NRC Back</a></nav> : <span className="ml-1">No Document</span>}</p>
                                            <p><strong>Status:</strong> <span className="text-capitalize">{userData.status} {userData.meta?.status === "rejected" ? "| " + userData?.meta?.remark : null}</span></p>
                                            <p><strong>Date Created:</strong> {moment(userData.date.str).format("Do MMM, YYYY")}</p>
                                            <p className="d-flex"><strong>Approver</strong>({userData?.approver ? <span className="tx-primary tx-bold">Active</span> : <span className="tx-danger tx-bold">Inactive</span>}): {userData?.approver ? <nav className="nav nav-icon-only mg-l-4"><a href="javascript:void(0)" onClick={handleApprove.bind(null, "approver")} className="nav-link"><i className="fa fa-ban"></i> Deactivate</a></nav> : <nav className="nav nav-icon-only mg-l-4"><a href="javascript:void(0)" onClick={handleApprove.bind(null, "approver")} className="nav-link"><i className="fa fa-check"></i> Activate</a></nav>}</p>
                                            <nav className="nav nav-icon-only"><a href="javascript:void(0)" onClick={handleApprove.bind(null, "approve")} className="nav-link"><i className="fa fa-check"></i> Approve</a> <a href="javascript:void(0)" onClick={handleReject.bind()} className="nav-link"><i className="fa fa-ban"></i> Reject</a></nav>
                                        </div>
                                    </div>
                                </div>

                                <div id="media" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Media Content List</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="#" onClick={(e) => {e.preventDefault(); $('#media-dt').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <table id="media-dt" className="table" style={{width: "100%"}}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-20p">Media Code</th>
                                                            <th className="wd-20p">Status</th>
                                                            <th className="wd-20p">Approved</th>
                                                            <th className="wd-20p">Date</th>
                                                            <th className="wd-20p">Action</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="fund" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div
                                                    className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Addresses</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="javascript:void(0)" className="tx-13 link-03 d-flex align-items-center lh-0 mg-l-10" onClick={() => $('#fund-dt').DataTable().ajax.reload()}><span className="icon ion-md-refresh tx-normal"> Reload</span></a>
                                                    </div>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <table id="fund-dt" className="table" width={"100%"}>
                                                        <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th className="wd-25p">Fund</th>
                                                            <th className="wd-25p">Business Type</th>
                                                            <th className="wd-25p">Reg Number</th>
                                                            <th className="wd-25p">Date</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="monetize" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Monetize</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => $('#monetize-dt').DataTable().ajax.reload()}><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <table id="monetize-dt" className="table" style={{width: "100%"}}>
                                                        <thead>
                                                        <tr>
                                                            <th className="wd-25p">Amount</th>
                                                            <th className="wd-25p">Type</th>
                                                            <th className="wd-25p">Date</th>
                                                            <th className="wd-25p">Action</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="withdrawal" className="tab-pane fade">
                                    <div className="row row-sm">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mg-b-0">Withdrawal</h6>
                                                    <div className="d-flex tx-18">
                                                        <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => $('#withdrawal-dt').DataTable().ajax.reload()}><i className="icon ion-md-refresh"></i></a>
                                                    </div>
                                                </div>
                                                <div className="card-body table-responsive">
                                                    <table id="withdrawal-dt" className="table table-hover" style={{width: "100%"}}>
                                                        <thead>
                                                        <tr>
                                                            <th className="wd-20p">TXN Number</th>
                                                            <th className="wd-20p">Gateway</th>
                                                            <th className="wd-20p">Amount</th>
                                                            <th className="wd-20p">Type</th>
                                                            <th className="wd-20p">Date</th>
                                                        </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog"
                         aria-labelledby="confirmation" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div className="modal-content tx-14">
                                <div className="modal-header">
                                    <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p className="mg-b-0 data-message">Empty</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" id="delete-data" className="btn btn-success btn-block">Yes,
                                        Delete
                                    </button>
                                    <button type="button" className="btn btn-danger btn-block mt-0"
                                            data-dismiss="modal">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalRejection" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <div className="media align-items-center">
                                        <div className="media-body">
                                            <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close" onClick={resetForm.bind(null, "modalRejection", "rejection_form")}>
                                                <span aria-hidden="true">&times;</span>
                                            </a>
                                            <h4 className="tx-18 tx-sm-20 mg-b-2">Reason</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="rejection_form" className="parsley-style-1" onSubmit={handleRejectionSubmit.bind()}>
                                        <div id="provinceWrapper" className="form-group parsley-input">
                                            <label>Select Reason</label>
                                            <select className="custom-select" id="reason" required>
                                                <option value="" disabled selected>Select</option>
                                                <option value="Image is not clear or readable">Image is not clear or readable</option>
                                                <option value="NRC card is not fully visible">NRC card is not fully visible</option>
                                                <option value="Name on the NRC does not match the name entered">Name on the NRC does not match the name entered</option>
                                                <option value="Document uploaded is not a Zambia NRC">Document uploaded is not a Zambia NRC</option>
                                                <option value="Signs of editing, tampering, or fake document">Signs of editing, tampering, or fake document</option>
                                            </select>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/><span id="status">Please Wait</span></button> : <button className="btn btn-success btn-block">Submit</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalDeposit" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalDeposit", "deposit_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Top Up Balance</h4><p className="tx-13 tx-color-02 mg-b-0">Deposit into account balance</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="deposit_form" className="parsley-style-1" onSubmit={handleDepositSubmit.bind()}>
                                        <div id="amountWrapper" className="form-group parsley-input">
                                            <label>Amount<span className="tx-danger">*</span></label>
                                            <input id="amount" type="number" className="form-control"
                                                   placeholder="Enter amount"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#amountWrapper" required/>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">Deposit</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="modalUser" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalUser", "user_form")} aria-label="Close"><span aria-hidden="true">×</span></a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">Edit User</h4>
                                        <p className="tx-13 tx-color-02 mg-b-0">Edit user information.</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="user_form" className="parsley-style-1" onSubmit={handleUserSubmit.bind()}>
                                        <div id="mobileWrapper" className="form-group parsley-input">
                                            <label>Mobile Number<span className="tx-danger">*</span></label>
                                            <input id="mobile" type="number" className="form-control"
                                                   placeholder="Enter mobile number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#mobileWrapper" required/>
                                        </div>

                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Full Name</label>
                                            <input id="name" type="text" className="form-control"
                                                   placeholder="Enter full name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper"/>
                                        </div>

                                        <div id="nrcWrapper" className="form-group parsley-input">
                                            <label>NRC</label>
                                            <input id="id_number" type="text" className="form-control"
                                                   placeholder="Enter NRC Number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nrcWrapper"/>
                                        </div>

                                        <div id="genderWrapper" className="form-group parsley-input">
                                            <label>Gender</label>
                                            <select className="custom-select" id="gender">
                                                <option value="" disabled selected>Select</option>
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                        </div>

                                        <div id="passwordWrapper" className="form-group parsley-input">
                                            <label>Password</label>
                                            <input id="password" type="text" className="form-control"
                                                   placeholder="Enter password"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#passwordWrapper"/>
                                        </div>

                                        {stateReady ? <button disabled className="btn btn-success btn-block"><span
                                                className="spinner-border spinner-border-sm mg-r-10" role="status"
                                                aria-hidden="true"/>Please Wait</button> :
                                            <button className="btn btn-success btn-block">Update User</button>}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="content-body">
            <div className="container d-flex justify-content-center ht-100p">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mg-t-10">Collecting Data</p>
                </div>
            </div>
        </div>
    )
};

export default MembershipData;
